import { ContextColor, getContextColorStyle } from "../utils/colors.utils";

export function useContextColorStyle(contextColorName?: ContextColor, colorName?: string | null): React.CSSProperties {
  return getContextColorStyle(contextColorName, colorName);
}